import React from 'react'
import PropTypes from 'prop-types'

// import { getGlobalParams } from 'config/config'
import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import FundsTable from '../../organisms/FundsTable'
import Loader from '../../atoms/Loader'

import './style.scss'

const FundsWatchList = ({
  id,
  watchlistTitle,
  watchlistTitleShort,
  totalResultConfig,
  watchListTableData,
  necessaryElements,
  necessaryFunctions,
  tableProps
}) => {
  // const { favListName } = getGlobalParams()
  // const favItems = localStorage.getItem(favListName) ? JSON.parse(localStorage.getItem(favListName)) : []

  const changeFavStatus = () => {}

  return (
    <div className="fil-fund-watchlist" id={`fil-fund-watchlist-id-${id}`}>
      <GridContainer>
        <Grid direction="grid-x">
          <Cell extraClasses="small-12 fil-fund-watchlist__header text-left">
            <span id={`${id}_title-large`} className="show-for-large">
              {watchlistTitle}
            </span>
            <span id={`${id}_title-small`} className="hide-for-large">
              {watchlistTitleShort}
            </span>
            {totalResultConfig && totalResultConfig.fundsCountInfo && (
              <span className="fil-fund-watchlist__header-funds-count hide-for-large">
                ({totalResultConfig.fundsCountInfo.totalFundsCount})
              </span>
            )}
          </Cell>
          <Cell extraClasses="small-12">
            {watchListTableData ? (
              <FundsTable
                {...{
                  id,
                  necessaryElements,
                  necessaryFunctions: { changeFavStatus, ...necessaryFunctions },
                  tableProps,
                  tableData: watchListTableData,
                  totalResultConfig: {
                    allFunds: watchListTableData.body || [],
                    displayNumerator: false,
                    ...totalResultConfig
                  }
                }}
              />
            ) : (
              <Loader />
            )}
          </Cell>
        </Grid>
      </GridContainer>
    </div>
  )
}

FundsWatchList.propTypes = {
  id: PropTypes.string.isRequired,
  watchListTableData: PropTypes.object,
  necessaryElements: PropTypes.object,
  necessaryFunctions: PropTypes.object,
  totalResultConfig: PropTypes.object,
  watchlistTitle: PropTypes.string,
  watchlistTitleShort: PropTypes.string,
  tableProps: PropTypes.object
}

FundsWatchList.defaultProps = {
  watchListTableData: null,
  necessaryFunctions: {},
  necessaryElements: {},
  totalResultConfig: {},
  watchlistTitle: 'My Watchlist',
  watchlistTitleShort: 'My Watchlist',
  tableProps: {}
}

export default FundsWatchList
